import React, { memo } from "react";
// utils
import { format } from "@swiggy-private/core-ui";
// components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
// constants
import { STATIC_TEXTS } from "@cart-client/constants/GiftingCart";
// styles
import { ItemCounterWrapper } from "./styles";

const ItemCounter = ({ count }: { count: number }) => {
    const text = count === 1 ? STATIC_TEXTS.ITEM_COUNTER : STATIC_TEXTS.ITEMS_COUNTER;
    if (count < 1) return null;
    return (
        <ItemCounterWrapper>
            <Text variant="V2.overline.neutral.medium" color="text_Low_Emphasis">
                {format(text, String(count))}
            </Text>
        </ItemCounterWrapper>
    );
};

export default memo(ItemCounter);
